import { Component, OnInit, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { EnergyService } from '../../../energy.service';
import { SharedUtils } from '../../../../../shared/shared.utils';
import { GeneralService } from '../../../../../shared/services/general.service';
import { SessionStateService } from '../../../../../core/services/session-state.service';

@Component({
  selector: 'app-consumption-gas-resume',
  templateUrl: './consumption-gas-resume.component.html',
  styleUrls: ['./consumption-gas-resume.component.scss']
})
export class ConsumptionGasResumeComponent implements OnInit {
  @Input() gasMeterId: String;
SharedUtils = SharedUtils;
/**Main*/
activeView = 'day';
mode = 'kWh';
selectionSeconds = '3600';
currentSelectedDate = new Date(Date.now());
selectedDate: string = this.getSelectedDate();
integrationPeriodType = '0';
gasReadings: number[];
public selectedMoments;
/**Aux */
totalValue: number;
max = new Date(Date.now());
maxValue = 0;
numberOfTariffs = 1;
allSchedules = true;
normalSchedules = true;
economicSchedules = true;
superEconomicSchedules = true;
noData = false;
nextArrowPossible = false;
previousView: string;
auxMode: number;
auxDayMode: number;
/**Chart Options */
public ChartOptions: any = {
  scaleShowVerticalLines: false,
  maintainAspectRatio: false,
  responsive: true,
  scales: {
    xAxes: [{
      stacked: true,
      gridLines: {
        color: '#ECECEC',
        display: false
      }
    }],
    yAxes: [{
      stacked: true,
      gridLines: {
        color: '#ECECEC',
        display: true
      },
      ticks: {
        min: 0 }
    }]
  }
};

public ChartType = 'bar';
public ChartLabels: string[];
public ChartLegend = false;
public ChartData: any[] = [];
public ChartColors: Array<any>;
totalConsumption: number;
totalConsumptionUnit: string;
/**Controls */
loaded = false;
  constructor(private datePipe: DatePipe,
              private energyService: EnergyService,
              private generalService: GeneralService,
              private sessionSateService: SessionStateService) { }

  ngOnInit() {
    this.updateGraphic();
  }
  setMode() {

    if (this.mode === 'kWh') {
      this.auxMode = 1;
    } else {
      this.auxMode = 2;
    }
  }

  setDayMode() {
    if (this.activeView === 'minute') {
      this.auxDayMode = 1;
    } else {
      this.auxDayMode = 2;
    }
  }
  updateGraphic() {
    if (this.selectedMoments) {
      this.currentSelectedDate = new Date(this.selectedMoments[0]);
    }
    this.ChartData = [];
    this.totalConsumption = 0;
    this.noData = false;
    this.setDayMode();
    this.setMode();
    if (this.activeView === 'day' || this.activeView === 'minute') {
      const dateFormat: string = (this.datePipe.transform(this.currentSelectedDate, 'MM-dd-yyyy'));
      this.energyService.getGasByDay(this.gasMeterId, dateFormat, this.auxMode, this.auxDayMode).subscribe(readings => {
        if (readings.length === 0) {
          this.noData = true;
        } else {
        this.gasReadings = readings;
        this.ChartColors = [{}];
        this.ChartLabels = this.getGasLabels(this.activeView, this.getRawLabels(readings));
            this.ChartData.push({
              data: this.getEnergyChartValues(this.gasReadings),
              label: this.generalService.translate.instant('Normal'), borderWidth: 0,
              stack: '1',
              backgroundColor: this.iterateColor('rgba(234, 82, 75, 1)')
            });
        this.maxValue = this.getMaxValue(this.gasReadings);
        if (this.maxValue === 0) {
          this.updateGraphNoData();
        }
        this.energyService.getGasTotalByDay(this.gasMeterId, dateFormat, this.auxMode, 2).subscribe(total => {
          if (total[0]) {
            this.totalConsumption = total[0].Value;
            this.totalConsumptionUnit = total[0].Unit;
          }
        });
        this.loaded = true;
      }
    }, (err => {
    }));
  } else if (this.activeView === 'month') {
      this.energyService.getGasByMonth(this.gasMeterId,  this.currentSelectedDate.getMonth() + 1,
       this.currentSelectedDate.getFullYear(), this.auxMode).subscribe(readings => {
        if (readings.length === 0) {
          this.noData = true;
        } else {
        this.gasReadings = readings;
        this.ChartColors = [{}];
        this.ChartLabels = this.getGasLabels(this.activeView, this.getRawLabels(readings));
            this.ChartData.push({
              data:  this.getEnergyChartValues(this.gasReadings),
              label: this.generalService.translate.instant('Normal'), borderWidth: 0,
              stack: '1',
              backgroundColor: this.iterateColor('rgba(234, 82, 75, 1)')
            });
            this.maxValue = this.getMaxValue(this.gasReadings);
            if (this.maxValue === 0) {
              this.updateGraphNoData();
            }
            this.energyService.getGasTotalByMonth(this.gasMeterId,  this.currentSelectedDate.getMonth() + 1,
            this.currentSelectedDate.getFullYear(), this.auxMode).subscribe(total => {
              if (total[0]) {
                this.totalConsumption = total[0].Value;
              }
          });
        this.loaded = true;
        }
    });
  } else if (this.activeView === 'year') {
    this.energyService.getGasByYear(this.gasMeterId,
     this.currentSelectedDate.getFullYear(), this.auxMode).subscribe(readings => {
      if (readings.length === 0) {
        this.noData = true;
      } else {
      this.gasReadings = readings;
      this.ChartColors = [{}];
      this.ChartLabels = this.getGasLabels(this.activeView, this.getRawLabels(readings));
          this.ChartData.push({
            data:  this.getEnergyChartValues(this.gasReadings),
            label: this.generalService.translate.instant('Normal'), borderWidth: 0,
            stack: '1',
            backgroundColor: this.iterateColor('rgba(234, 82, 75, 1)'),
          });
          this.maxValue = this.getMaxValue(this.gasReadings);
          if (this.maxValue === 0) {
            this.updateGraphNoData();
          }
        this.energyService.getGasTotalByYear(this.gasMeterId,
          this.currentSelectedDate.getFullYear(), this.auxMode).subscribe(total => {
          if (total[0]) {
            this.totalConsumption = total[0].Value;
          }
      });
      this.loaded = true;
    }
  });
  }

}

  // getGasLabels(gasReadings: any): string[] {
  //   const labels: string[] = new Array();
  //   gasReadings.forEach(element => {
  //     if (this.activeView === 'day') {
  //       labels.push(String(this.getHour(element.Timestamp)) + 'h');
  //     } else if (this.activeView === 'month') {
  //       labels.push(String(this.toDate(element.Day).getUTCDate()));
  //     } else if (this.activeView === 'year') {
  //       const month: string = element.Month;
  //       labels.push(month.charAt(0).toUpperCase() + month.substr(1, month.length).toLowerCase());
  //     }
  //   });
  //   return labels;
  // }
  getRawLabels(chart: any): Array<string> {
    const labels: Array<string> = new Array<string>();
    if (this.activeView === 'day') {
      chart.forEach(entry => {
        labels.push(entry.Timestamp);
      });
    } else if (this.activeView === 'month') {
      chart.forEach(entry => {
        labels.push(entry.Day);
      });
    } else if (this.activeView === 'year') {
      chart.forEach(entry => {
        labels.push(entry.Month);
      });
    }
    return labels;
  }

  getGasLabels(activeView: string, rawLabels: Array<string>): string[] {
    const labels: string[] = new Array();
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'];
    /**Day View*/
    if (!this.selectedMoments) {
      if (activeView === 'day') {
        for (let h = 0; h < 24; h++) {
          let hour: string = String(h);
          if (hour.length === 1) {
            hour = '0' + hour;
          }
          labels.push(String(hour).concat('h'));
        }
        /**15m View*/
      } if (activeView === 'minute') {
        for (let h = 0; h < 24; h++) {
          let hour: string = String(h);
          if (hour.length === 1) {
            hour = '0' + hour;
          }
          for (let m = 0; m < 60; m = m + 15) {
            let minute: string = String(m);
            if (minute.length === 1) {
              minute = '0' + minute;
            }
            labels.push(hour + ':' + minute);
          }
        }
        /**Month View*/
      } else if (activeView === 'month') {
        let auxDate;
        if (rawLabels[0]) {
          auxDate = new Date(rawLabels[0].split('-').reverse().join('-'));
        }
        const lastDayOfMonth = new Date(auxDate.getFullYear(), auxDate.getMonth() + 1, 0).getDate();
        for (let d = 1; d < (lastDayOfMonth + 1); d++) {
          labels.push(String(d));
        }
        /**Anual View*/
      } else if (activeView === 'year') {
        for (let i = 0; i < 12; i++) {
          labels.push((monthNames[i]).toString());
        }
      }
    } else {
      const dateF: Date = new Date(this.selectedMoments[0]);
      let dateT: Date = new Date();
      if (this.selectedMoments[1]) {
        dateT = new Date(this.selectedMoments[1]);
      } else {
        dateT = new Date(this.selectedMoments[0]);
      }
      const interval: number = (Math.abs(dateT.getTime() - dateF.getTime()) / (1000 * 3600 * 24));
      if (this.activeView !== 'Q') {
        if (interval < 1) {
          for (let h = 0; h < 24; h++) {
            let hour: string = String(h);
            if (hour.length === 1) {
              hour = '0' + hour;
            }
            labels.push(String(hour).concat('h'));
          }
        } else if (interval >= 30) {
          const startMonth = dateF.getMonth();
          const endMonth = dateT.getMonth();
          if (interval < 365) {
            const otherYear = startMonth >= endMonth ? true : false;
            if (otherYear) {
              for (let m = startMonth; m <= 11; m++) {
                labels.push((monthNames[m].toString()));
              }
              for (let m = 0; m <= endMonth; m++) {
                labels.push((monthNames[m].toString()));
              }
            } else {
              for (let m = startMonth; m <= endMonth || otherYear; m++) {
                labels.push((monthNames[m].toString()));
              }
            }
          } else {
            for (let yN = 0; yN <= interval / 365; yN++) {
              for (let m = (yN === 0) ? startMonth : 0; (m <= 11 && (yN + 1 ) < interval / 365) || (yN > 0 && m <= endMonth) ; m++) {
                labels.push((monthNames[m].toString()));
              }
            }
          }
        } else {
          for (let d = dateF.getDate(); d < (dateT.getDate() + 1); d++) {
            labels.push(String(d));
          }
        }
      } else {
        for (let h = 0; h < 24; h++) {
          let hour: string = String(h);
          if (hour.length === 1) {
            hour = '0' + hour;
          }
          for (let m = 0; m < 60; m = m + 15) {
            let minute: string = String(m);
            if (minute.length === 1) {
              minute = '0' + minute;
            }
            labels.push(hour + ':' + minute);
          }
        }
      }
    }
    return labels;
  }

  getGasData(gasReadings: any): number[] {
    const labels: number[] = new Array();
    gasReadings.forEach(element => {
      labels.push(element.Value);
    });
    return labels;
  }

  minuteSelection() {
    if (this.activeView !== 'minute') {
      this.previousView = this.activeView;
      // this.currentSelectedDate = new Date(Date.now());
      this.activeView = 'minute';
      this.selectionSeconds = '900';
      this.refreshVisualDataRepresentation();
    } else {
      if (this.previousView === 'day') {
        this.daySelection(false);
      } else if (this.previousView === 'month') {
        this.monthSelection();
      } else if (this.previousView === 'year') {
        this.yearSelection();
      }
    }
  }

  daySelection(hourView: boolean, reset?: boolean) {
    if (!this.selectedMoments || this.activeView === 'Custom' || hourView) {
      this.nextArrowPossible = false;
      if (reset) {
        this.currentSelectedDate = new Date(Date.now());
      }
      this.activeView = 'day';
      this.integrationPeriodType = '0';
      this.selectionSeconds = '3600';
      this.refreshVisualDataRepresentation();
    }
  }

  monthSelection() {
    const present = new Date(Date.now());
    if (!this.selectedMoments || this.activeView === 'Custom') {
      this.nextArrowPossible = false;
      this.currentSelectedDate = new Date(present.getFullYear() , present.getMonth() , 1);
      this.activeView = 'month';
      this.integrationPeriodType = '0';
      this.selectionSeconds = '86400';
      this.refreshVisualDataRepresentation();
    }
  }

  yearSelection() {
    const present = new Date(Date.now());
    if (!this.selectedMoments || this.activeView === 'Custom') {
      this.nextArrowPossible = false;
      this.currentSelectedDate = new Date(present.getFullYear() , 0 , 1);
      this.activeView = 'year';
      this.integrationPeriodType = '1';
      this.selectionSeconds = '1';
      this.refreshVisualDataRepresentation();
    }
  }

  energyModeSelection() {
    this.mode = 'kWh';
    this.refreshVisualDataRepresentation();
  }

  moneyModeSelection() {
    this.mode = 'Eur';
    this.refreshVisualDataRepresentation();
  }

  isToday(date: Date): boolean {
    const today = new Date(Date.now());
    return (today.getDate() === date.getDate() && today.getMonth() === date.getMonth()
      && today.getFullYear() === date.getFullYear());
  }

  getSelectedDate(): string {
    if (this.selectedMoments) {
        return 'Custom';
    }
    if (this.activeView === 'day' || this.activeView === 'minute') {
      if (this.isToday(this.currentSelectedDate)) {
        return 'Today';
      } else {
        return this.datePipe.transform(this.currentSelectedDate, 'yyyy-MM-dd');
      }
    } else if (this.activeView === 'month') {
      return this.datePipe.transform(this.currentSelectedDate, 'LLLL');
    } else if (this.activeView === 'year') {
      return this.datePipe.transform(this.currentSelectedDate, 'yyyy');
    }
  }

  moveDateBack() {
    if (!this.selectedMoments) {
      if (!this.nextArrowPossible) {
        this.nextArrowPossible = !this.nextArrowPossible;
      }
      if (this.activeView === 'day' || this.activeView === 'minute') {
        this.currentSelectedDate = new Date(this.currentSelectedDate.getFullYear(),
          this.currentSelectedDate.getMonth(), this.currentSelectedDate.getDate() - 1);
      }
      if (this.activeView === 'month') {
        this.currentSelectedDate = new Date(this.currentSelectedDate.getFullYear(),
          this.currentSelectedDate.getMonth() - 1, this.currentSelectedDate.getDate());
      }
      if (this.activeView === 'year') {
        this.currentSelectedDate = new Date(this.currentSelectedDate.getFullYear() - 1,
          this.currentSelectedDate.getMonth(), this.currentSelectedDate.getDate());
      }
      this.refreshVisualDataRepresentation();
    }
  }

  moveDateFoward() {
    const today: Date = new Date(Date.now());
    let fowardDate: Date = new Date();
    // Foward verifications to allow the arrow to be presented
    if (this.activeView === 'day' || this.activeView === 'minute') {
      fowardDate = new Date(this.currentSelectedDate.getFullYear(),
      this.currentSelectedDate.getMonth(), this.currentSelectedDate.getDate() + 2);
    }
    if (this.activeView === 'month') {
      fowardDate = new Date(this.currentSelectedDate.getFullYear(),
      this.currentSelectedDate.getMonth() + 2 , this.currentSelectedDate.getDate());
    }
    if (this.activeView === 'year') {
      fowardDate = new Date(this.currentSelectedDate.getFullYear() + 2,
      this.currentSelectedDate.getMonth(), this.currentSelectedDate.getDate());
    }

    if (fowardDate.valueOf() > today.valueOf()) {
      this.nextArrowPossible = false;
    }
    if (!this.selectedMoments) {
        const minChange: Date = new Date(this.currentSelectedDate.getFullYear(),
        this.currentSelectedDate.getMonth(), this.currentSelectedDate.getDate() + 1);
        if (minChange.valueOf() < today.valueOf()) {
          if (this.activeView === 'day' || this.activeView === 'minute') {
            this.currentSelectedDate = new Date(this.currentSelectedDate.getFullYear(),
              this.currentSelectedDate.getMonth(), this.currentSelectedDate.getDate() + 1);
          }
          if (this.activeView === 'month') {
            this.currentSelectedDate = new Date(this.currentSelectedDate.getFullYear(),
              this.currentSelectedDate.getMonth() + 1, this.currentSelectedDate.getDate());
          }
          if (this.activeView === 'year') {
            this.currentSelectedDate = new Date(this.currentSelectedDate.getFullYear() + 1,
              this.currentSelectedDate.getMonth(), this.currentSelectedDate.getDate());
          }
          this.refreshVisualDataRepresentation();
        } else {
          this.nextArrowPossible = false;
        }
      }
  }


  refreshVisualDataRepresentation() {
    this.selectedDate = this.getSelectedDate();
    this.updateGraphic();
  }

  getRespectiveEndDate(): Date {

    if (!this.selectedMoments) {
      if (this.activeView === 'day' || this.activeView === 'minute') {
        return new Date(this.currentSelectedDate.getFullYear(),
          this.currentSelectedDate.getMonth(), this.currentSelectedDate.getDate() + 1);
      }
      if (this.activeView === 'month') {
        return new Date(this.currentSelectedDate.getFullYear(),
          this.currentSelectedDate.getMonth() + 1, this.currentSelectedDate.getDate());
      }
      if (this.activeView === 'year') {
        return new Date(this.currentSelectedDate.getFullYear() + 1,
          this.currentSelectedDate.getMonth(), this.currentSelectedDate.getDate());
      }
    } else {
      if (this.selectedMoments[1] !== null) {
        return new Date(this.selectedMoments[1].getFullYear(), this.selectedMoments[1].getMonth(), this.selectedMoments[1].getDate() + 1);
      } else {
        return new Date(this.selectedMoments[0].getFullYear(), this.selectedMoments[0].getMonth(), this.selectedMoments[0].getDate() + 1);
      }
    }
  }

  getMaxValue(readings: number[]) {
      let max = 0;
      const normalValues: number[] = readings;
      max = Math.max.apply(Math , this.cleanArray(normalValues));
      return max;
  }

  cleanArray(actual) {
    const newArray = new Array();
    for (let i = 0; i < actual.length; i++) {
      if (actual[i]) {
        newArray.push(actual[i].Value);
      }
    }
    return newArray;
  }

  allTariffsActive(): boolean {
    return this.normalSchedules && this.economicSchedules && this.superEconomicSchedules;
  }

  activateAllSchedules() {
    if (!this.allSchedules) {
      this.normalSchedules = true;
      this.economicSchedules = true;
      this.superEconomicSchedules = true;
      this.allSchedules = true;
      this.refreshVisualDataRepresentation();
    }
  }

  minimumScheduleActive(): boolean {
    if (this.numberOfTariffs === 3) {
      return (this.normalSchedules && this.economicSchedules) ||
        (this.normalSchedules && this.superEconomicSchedules) ||
        (this.economicSchedules && this.superEconomicSchedules);
    } else if (this.numberOfTariffs === 2) {
      return this.economicSchedules && this.normalSchedules;
    } else if (this.numberOfTariffs === 1) {
      return false;
    }
  }

  toggleNormalSchedule() {
    if (this.minimumScheduleActive() || !this.normalSchedules) {
      this.normalSchedules = !this.normalSchedules;
      if (this.allSchedules) {
        this.allSchedules = false;
      } else if (this.allTariffsActive()) {
        this.allSchedules = true;
      }
      this.refreshVisualDataRepresentation();
    }
  }

  toggleEconomicSchedule() {
    if (this.minimumScheduleActive() || !this.economicSchedules) {
      this.economicSchedules = !this.economicSchedules;
      if (this.allSchedules) {
        this.allSchedules = false;
      } else if (this.allTariffsActive()) {
        this.allSchedules = true;
      }
      this.refreshVisualDataRepresentation();
    }
  }

  toggleSuperEconomicSchedule() {
    if (this.minimumScheduleActive() || !this.superEconomicSchedules) {
      this.superEconomicSchedules = !this.superEconomicSchedules;
      if (this.allSchedules) {
        this.allSchedules = false;
      } else if (this.allTariffsActive()) {
        this.allSchedules = true;
      }
      this.refreshVisualDataRepresentation();
    }
  }

  convertToBoolean(input: string): boolean | undefined {
    try {
      return JSON.parse(input);
    } catch (e) {
      return undefined;
    }
  }

  updateGraphNoData() {
    this.noData = true;
    this.chartNoDataConfig();
    this.ChartLabels = [''];
    this.ChartData = [{ data: [''], label: this.mode, borderWidth: 0 }];
    this.totalValue = 0;
    this.loaded = true;
  }

  clearFilter() {
    // this.selectedMoments = null;
    // this.daySelection(false);
    this.selectedMoments = null;
    if (this.activeView === 'day') {
      this.daySelection(false, true);
    } else if (this.activeView === 'month') {
      this.monthSelection();
    } else if (this.activeView === 'year') {
      this.yearSelection();
    }
  }

  formatDates(dateFrom: string, dateTo: string): string {
    const dateF: Date = new Date(dateFrom);
    const dateT: Date = new Date(dateTo);
    if (dateTo) {
      return this.generalService.translate.instant('From: ') + this.datePipe.transform(dateF, 'yyyy-MM-dd') +
      this.generalService.translate.instant(' To: ') + this.datePipe.transform(dateT, 'yyyy-MM-dd');
    } else {
      return this.generalService.translate.instant('From: ') + this.datePipe.transform(dateF, 'yyyy-MM-dd') +
      this.generalService.translate.instant(' To: ') + this.datePipe.transform(dateF, 'yyyy-MM-dd');
    }
  }

  onChange(selectedMoments) {
    if (this.selectedMoments.length !== 0) {
      this.activeView = 'Custom';
      this.selectedDate = this.getSelectedDate();
      const dateF: Date = new Date(this.selectedMoments[0]);
      let dateT: Date = new Date();
      if (this.selectedMoments[1]) {
        dateT = new Date(this.selectedMoments[1]);
      } else {
        dateT = new Date(this.selectedMoments[0]);
      }
      this.calculateView(dateF, dateT);
    } else {
      this.selectedMoments = null;
    }
  }

  calculateView(dateFrom: Date, dateTo: Date) {
    const diff: number = dateTo.valueOf() - dateFrom.valueOf();
    const seconds = diff / 1000;
    if (seconds < 86400) {
      this.daySelection(false);
    } else if ( seconds > 2592000) {
      this.yearSelection();
    } else {
      this.monthSelection();
    }
  }

  iterateColor(color: string): string[] {
    const array: string[] = new Array();
    for (let i = 0; i < 120; i++) {
      array.push(color);
    }
    return array;
  }

  toDate(dateStr) {
    const [day, month, year] = dateStr.split('-');
    return new Date(Number(year), Number(month) - 1, Number(day), 1 );
  }
  getHour(dateStr) {
    return dateStr.split(' ')[1].split(':')[0];
  }

  chartNoDataConfig() {
    this.ChartOptions = {
      scaleShowVerticalLines: false,
      maintainAspectRatio: false,
      responsive: true,
      scales: {
        xAxes: [{
          stacked: true,
          gridLines: {
            color: '#ECECEC',
            display: false
          }
        }],
        yAxes: [{
          gridLines: {
            color: '#ECECEC',
            display: false
          },
          ticks: { min: 0 }
        }]
      }
    };
  }
  getLanguage() {
    return this.sessionSateService.getLang();
  }

  getEnergyChartValues(response: Array<any>): Array<string> {
    let dataNormal: Array<string> = new Array();
    const presentValuesNormal: Map<string, any> = new Map<string, any>();
    let auxHour;
    let auxMinutes;
    let auxMonth;
    let auxDate: Date = new Date();
    response.forEach(entry => {
      if (this.activeView === 'day') {
       auxHour =  entry.Timestamp.substring(11, 13);
       auxMinutes = entry.Timestamp.substring(14, 16);
      } else if (this.activeView === 'month') {
        /**Format string to YYYY-MM-DD */
        const dateStr = entry.Day.substring(0, 10).split('-').reverse().join('-');
        auxDate = new Date(Date.parse(dateStr));
      } else if (this.activeView === 'year') {
        const monthNames = ['january', 'february', 'march', 'april', 'may', 'june',
        'july', 'august', 'september', 'october', 'november', 'december'];
        auxMonth = monthNames.indexOf(entry.Month);
      }
      /** Check Present values */
        if (this.activeView === 'day') {
          if (entry.Value) { presentValuesNormal.set(String(auxHour.replace(/^0+/, '')), Number(entry.Value).toFixed(2)); }
        } else if (this.activeView === 'minute') {
          if (entry.Value) {
            presentValuesNormal.set(String(auxHour + ':' + auxMinutes), Number(entry.Value).toFixed(2));
          }
        } else if (this.activeView === 'month') {
          // if (entry.Value) { presentValuesNormal.set(String(auxDate.getDate()), Number(entry.Value).toFixed(2)); }
          for (let i = 1; i <= 12; i++) {
            if (!this.selectedMoments) {
              if (presentValuesNormal.has(String(i))) {
                dataNormal.push(presentValuesNormal.get(String(i)));
              } else {
                dataNormal.push('0');
              }
            } else {
              const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'];

              const dateF: Date = new Date(this.selectedMoments[0]);
              let dateT: Date = new Date();
              if (this.selectedMoments[1]) {
                dateT = new Date(this.selectedMoments[1]);
              } else {
                dateT = new Date(this.selectedMoments[0]);
              }

              const interval: number = (Math.abs(dateT.getTime() - dateF.getTime()) / (1000 * 3600 * 24));

              const startMonth = dateF.getMonth();
              const endMonth = dateT.getMonth();

              // if (this.ChartLabels.indexOf(monthNames[i - 1]) !== -1) {
              //   if (presentValues.has(String(i))) {
              //     values.push(presentValues.get(String(i)));
              //   } else {
              //     values.push('0');
              //   }
              // }
              if (interval < 365) {
                const otherYear = startMonth >= endMonth ? true : false;
                if (otherYear) {
                  for (let m = startMonth; m <= 11; m++) {
                    if (presentValuesNormal.has(String(m + 1))) {
                      dataNormal.push(presentValuesNormal.get(String(m + 1)));
                    } else {
                      dataNormal.push('0');
                    }
                  }
                  for (let m = 0; m <= endMonth; m++) {
                    if (presentValuesNormal.has(String(m + 1))) {
                      dataNormal.push(presentValuesNormal.get(String(m + 1)));
                    } else {
                      dataNormal.push('0');
                    }
                  }
                } else {
                  for (let m = startMonth; m <= endMonth || otherYear; m++) {
                    if (presentValuesNormal.has(String(m + 1))) {
                      dataNormal.push(presentValuesNormal.get(String(m + 1)));
                    } else {
                      dataNormal.push('0');
                    }
                  }
                }
              } else {
                for (let yN = 0; yN <= interval / 365; yN++) {
                  for (let m = (yN === 0) ? startMonth : 0; (m <= 11 && (yN + 1 ) < interval / 365) || (yN > 0 && m <= endMonth) ; m++) {
                    if (presentValuesNormal.has(String(m + 1))) {
                      dataNormal.push(presentValuesNormal.get(String(m + 1)));
                    } else {
                      dataNormal.push('0');
                    }
                  }
                }
              }
            }
          }
        } else if (this.activeView === 'year') {
          if (entry.Value) { presentValuesNormal.set(String(auxMonth + 1), Number(entry.Value).toFixed(2)); }
        }
    });
      dataNormal = this.addParsedValues(presentValuesNormal, auxDate);

      return dataNormal;
  }

  addParsedValues(presentValues: Map<string, any>, auxDate: Date): Array<string> {
    const values: Array<string> = new Array<string>();
    if (this.activeView === 'day') {
      for (let d = 0; d < 24; d++) {
        if (presentValues.has(String(d))) {
          values.push(presentValues.get(String(d)));
        } else {
          values.push('0');
        }
      }
    } else if (this.activeView === 'minute') {
      for (let h = 0; h < 24; h++) {
        let hour: string = String(h);
        if (hour.length === 1) {
          hour = '0' + hour;
        }
        for (let m = 0; m < 60; m = m + 15) {
          let minute: string = String(m);
          if (minute.length === 1) {
            minute = '0' + minute;
          }
          if (presentValues.has(String(h) + ':' + String(m))) {
            values.push(presentValues.get(String(h) + ':' + String(m)));
          } else {
            values.push('0');
          }
        }
      }
    } else if (this.activeView === 'month') {
      const lastDayOfMonth = new Date(auxDate.getFullYear(), auxDate.getMonth() + 1, 0).getDate();
      for (let d = 1; d < (lastDayOfMonth + 1); d++) {
        if (!this.selectedMoments) {
          if (presentValues.has(String(d))) {
            values.push(presentValues.get(String(d)));
          } else {
            values.push('0');
          }
        } else {
          if (this.ChartLabels.indexOf(String(d)) !== -1) {
            if (presentValues.has(String(d))) {
              values.push(presentValues.get(String(d)));
            } else {
              values.push('0');
            }
          }
        }
      }
    } else if (this.activeView === 'year') {
      for (let i = 1; i <= 12; i++) {
        if (!this.selectedMoments) {
          if (presentValues.has(String(i))) {
            values.push(presentValues.get(String(i)));
          } else {
            values.push('0');
          }
        } else {
          const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'];
          if (this.ChartLabels.indexOf(monthNames[i - 1]) !== -1) {
            if (presentValues.has(String(i))) {
              values.push(presentValues.get(String(i)));
            } else {
              values.push('0');
            }
          }
        }
      }
    }
    return values;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/energy/energy-resume/consumption-resume/consumption-gas-resume/consumption-gas-resume.component.ts